import type { IconName } from './components/Icon';

export interface NavItem {
  key: string;
  label: string;
  to: string;
  icon: IconName;
}

export interface NavGroup {
  label: string | null;
  items: NavItem[];
}

/** Sidebar groups, in the order of design/Sidebar.dc.html. Single source for nav and routes. */
export const NAV: NavGroup[] = [
  { label: null, items: [{ key: 'inicio', label: 'Início', to: '/', icon: 'home' }] },
  {
    label: 'Vender',
    items: [
      { key: 'qq', label: 'Orçamento rápido', to: '/orcamento-rapido', icon: 'calculator' },
      { key: 'orcamentos', label: 'Orçamentos', to: '/orcamentos', icon: 'quote' },
      { key: 'pedidos', label: 'Pedidos', to: '/pedidos', icon: 'box' },
      { key: 'clientes', label: 'Clientes', to: '/clientes', icon: 'users' },
    ],
  },
  {
    label: 'Produzir',
    items: [
      { key: 'fila', label: 'Fila de impressão', to: '/fila', icon: 'queue' },
      { key: 'impressoras', label: 'Impressoras', to: '/impressoras', icon: 'printer' },
    ],
  },
  {
    label: 'Catálogo',
    items: [
      { key: 'produtos', label: 'Produtos', to: '/produtos', icon: 'tag' },
      { key: 'midia', label: 'Biblioteca de mídia', to: '/midia', icon: 'image' },
    ],
  },
  {
    label: 'Estoque',
    items: [
      { key: 'filamentos', label: 'Filamentos e carretéis', to: '/filamentos', icon: 'spool' },
      { key: 'insumos', label: 'Insumos', to: '/insumos', icon: 'supplies' },
    ],
  },
  {
    label: 'Dinheiro',
    items: [
      { key: 'despesas', label: 'Despesas', to: '/despesas', icon: 'card' },
      { key: 'relatorios', label: 'Relatórios', to: '/relatorios', icon: 'chart' },
    ],
  },
];

export const SETTINGS: NavItem[] = [
  { key: 'custos', label: 'Negócio e custos', to: '/configuracoes/custos', icon: 'gear' },
  { key: 'canais', label: 'Canais', to: '/configuracoes/canais', icon: 'gear' },
  { key: 'usuarios', label: 'Usuários', to: '/configuracoes/usuarios', icon: 'gear' },
  { key: 'dados', label: 'Dados e backups', to: '/configuracoes/dados', icon: 'gear' },
];

/** Global "Novo" menu (design/Topbar.dc.html). */
export const NEW_MENU: { label: string; to: string; icon: IconName }[] = [
  { label: 'Orçamento', to: '/orcamento-rapido', icon: 'calculator' },
  { label: 'Pedido', to: '/pedidos/novo', icon: 'box' },
  { label: 'Impressão', to: '/fila?nova=1', icon: 'queue' },
  { label: 'Compra de carretéis', to: '/filamentos/compra', icon: 'spool' },
  { label: 'Despesa', to: '/despesas/nova', icon: 'card' },
];

/** Phone bottom bar: Orçar · Fila · Pedidos · Estoque · Mais. */
export const BOTTOM_BAR: { label: string; to: string; icon: IconName; match: string[] }[] = [
  {
    label: 'Orçar',
    to: '/orcamento-rapido',
    icon: 'calculator',
    match: ['/orcamento-rapido', '/orcamentos'],
  },
  { label: 'Fila', to: '/fila', icon: 'queue', match: ['/fila', '/impressoras'] },
  { label: 'Pedidos', to: '/pedidos', icon: 'box', match: ['/pedidos'] },
  {
    label: 'Estoque',
    to: '/estoque',
    icon: 'spool',
    match: ['/estoque', '/filamentos', '/insumos', '/carreteis', '/c/'],
  },
  {
    label: 'Mais',
    to: '/mais',
    icon: 'menu',
    match: [
      '/mais',
      '/',
      '/clientes',
      '/configuracoes',
      '/produtos',
      '/midia',
      '/despesas',
      '/relatorios',
    ],
  },
];

export const ALL_ITEMS: NavItem[] = [...NAV.flatMap((g) => g.items), ...SETTINGS];

/** The nav item a path belongs to (longest matching prefix), for titles and crumbs. */
export function navItemFor(pathname: string): NavItem | undefined {
  if (pathname === '/') return ALL_ITEMS[0];
  return ALL_ITEMS.filter((i) => i.to !== '/' && pathname.startsWith(i.to)).toSorted(
    (a, b) => b.to.length - a.to.length,
  )[0];
}
